import React, { useContext } from "react";
import styled from "styled-components";

import { BetterTabs } from "@examspark/common-ui/dist/components/tabs/Tabs";

import { NewActivityContext } from "../../../classroom";

import { ActivityBuilderForm } from "./ActivityBuilderForm";
import { ActivityEditorItems } from "./ActivityEditorItems";
import ActivityEditorPreview from "./ActivityEditorPreview";

const Styled = styled.div`
  display: flex;
  flex-direction: column;

  flex: 1;

  font-family:
    proxima-nova,
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    "Roboto",
    "Oxygen",
    "Ubuntu",
    "Cantarell",
    "Fira Sans",
    "Droid Sans",
    "Helvetica Neue",
    sans-serif;
`;

type ActivityBuilderProps = {
  tab: string;
  setTab: (tab: string) => void;

  tabOverride?: {
    basic?: React.ReactNode;
    items?: React.ReactNode;
    preview?: React.ReactNode;
  };
};

/** @deprecated replace someday with `ActivityEditor` */
const ActivityBuilder = (props: ActivityBuilderProps) => {
  const { tab, setTab } = props;

  const [state] = useContext(NewActivityContext);

  return (
    <Styled>
      <BetterTabs
        activeTab={tab}
        onTabChange={setTab}
        tabs={[
          {
            label: "Basic",
            tab: "basic",
            element: props.tabOverride?.basic ? (
              props.tabOverride?.basic
            ) : (
              <ActivityBuilderForm />
            ),
          },
          {
            label: "Items",
            tab: "items",
            hidden: !state.isInitialized,
            element: props.tabOverride?.items ? (
              props.tabOverride?.items
            ) : (
              <ActivityEditorItems />
            ),
          },
          {
            label: "Preview",
            tab: "preview",
            hidden: !state.isInitialized,
            element: props.tabOverride?.preview ? (
              props.tabOverride?.preview
            ) : (
              <ActivityEditorPreview />
            ),
          },
        ]}
      />
    </Styled>
  );
};

export default ActivityBuilder;
